import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Text } from '../../components/Text';
import Hint from '../../components/ModuleDrawer/Hint';
import { LoadingBar } from '../../components/util/LoadingBar';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { Radio } from 'rmwc/Radio';
import { SelectControl } from '../../components/controls/SelectControl';
import { updateDashboardData } from '../../actions/dashboardActions';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const StyledAnswerRow = styled.div`
  width: 80%;
`;

const lifeInsuranceSpec = {
  field_type: 'single_choice',
  options: ['uninsured', 'term', 'whole'],
  option_data: {
    uninsured: { label: 'No Life Insurance' },
    term: { label: 'Term Life Insurance' },
    whole: { label: 'Whole Life Insurance' },
  },
};

class ProtectingFamily extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryCoverage: props.qna_hash.primaryCoverage ? props.qna_hash.primaryCoverage.answer : null,
      partnerCoverage: props.qna_hash.partnerCoverage ? props.qna_hash.partnerCoverage.answer : null,
      willAndBeneficiary: props.qna_hash.willAndBeneficiary ? props.qna_hash.willAndBeneficiary.answer : null,
    };
  }
  componentDidMount() {
    this.props.pathAware('primaryCoverage');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.primaryCoverage) {
      let mergeState = {
        primaryCoverage: props.qna_hash.primaryCoverage.answer,
        willAndBeneficiary: props.qna_hash.willAndBeneficiary.answer,
      };
      if (props.qna_hash.hasPartner.answer) {
        mergeState.partnerCoverage = props.qna_hash.partnerCoverage.answer;
      }
      this.setState(mergeState);
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    let frame = {
      primaryCoverage: {
        question: 'Do you have any life insurance coverage?',
        answer: this.state.primaryCoverage,
      },
      willAndBeneficiary: {
        question: 'Do you have an up-to-date will and beneficiary information?',
        answer: this.state.willAndBeneficiary,
      },
    };

    if (qna_hash.hasPartner.answer) {
      frame.partnerCoverage = {
        question: 'Does your spouse have any life insurance coverage?',
        answer: this.state.partnerCoverage,
      };
    }

    this.props.continueOnboarding(qna_stack, qna_hash, frame).then(onContinue);
  };

  _canContinue = () => {
    if (this.props.qna_hash.hasPartner.answer) {
      return this.state.willAndBeneficiary !== null && this.state.primaryCoverage && this.state.partnerCoverage;
    } else {
      return this.state.willAndBeneficiary !== null && this.state.primaryCoverage;
    }
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(() => this.props.onBack());
  };

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.value });
  };

  render() {
    const { qna_hash, wrapper } = this.props;
    const { partnerCoverage, primaryCoverage, willAndBeneficiary } = this.state;

    if (!qna_hash.hasPartner) {
      return <LoadingBar />;
    }

    return (
      <DynamicWrapper
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">Do you have an up-to-date will and beneficiary information?</Text>
        </div>
        <div className="mb-4">
          <Radio
            id="willAndBeneficiaryTrue"
            value="yes"
            checked={willAndBeneficiary === true}
            onChange={evt => this.setState({ willAndBeneficiary: true })}
          >
            <Typography use="subtitle1">Yes</Typography>
          </Radio>

          <span className="ml-4">
            <Radio
              id="willAndBeneficiaryFalse"
              value="no"
              checked={willAndBeneficiary === false}
              onChange={evt => this.setState({ willAndBeneficiary: false })}
            >
              <Typography use="subtitle1">No</Typography>
            </Radio>
          </span>
        </div>
        <Text className="mt-4 mb-0" use="headline6">
          Do you have any life insurance coverage?
        </Text>
        <StyledAnswerRow>
          <SelectControl
            id="primaryCoverage"
            style={{ minHeight: '57px', width: '100%' }}
            label="You"
            value={primaryCoverage}
            spec={lifeInsuranceSpec}
            onChange={e => this.onChange(e, 'primaryCoverage')}
          />
        </StyledAnswerRow>
        {qna_hash.hasPartner.answer && (
          <StyledAnswerRow>
            <SelectControl
              id="partnerCoverage"
              style={{ minHeight: '57px', width: '100%' }}
              label="Your Spouse"
              value={partnerCoverage}
              spec={lifeInsuranceSpec}
              onChange={e => this.onChange(e, 'partnerCoverage')}
            />
          </StyledAnswerRow>
        )}
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(ProtectingFamily);
